import { render } from "./Officers.vue?vue&type=template&id=6bae8b45&scoped=true"
import script from "./Officers.vue?vue&type=script&lang=js"
export * from "./Officers.vue?vue&type=script&lang=js"

import "./Officers.vue?vue&type=style&index=0&id=6bae8b45&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6bae8b45"

export default script